/**
 * Helpers for the signed-up-but-unverified change-email path.
 * Marketplace changeEmail still needs the signup password on the server;
 * the verify screen must not ask the user to log in again.
 */

let rememberedSignupPassword = null;

/**
 * Keep the signup / login password in memory for this tab so the verify
 * screen can correct a typo without a password field.
 *
 * @param {unknown} password
 */
export const rememberSignupPassword = password => {
  rememberedSignupPassword = typeof password === 'string' && password.length > 0 ? password : null;
};

/**
 * Password remembered for this tab, if any.
 *
 * @returns {string|null}
 */
export const takeSignupPassword = () => rememberedSignupPassword;

/**
 * Drop the in-memory grant (logout or verified).
 */
export const clearSignupPassword = () => {
  rememberedSignupPassword = null;
};

/**
 * True when this session may change email without a verified-account re-auth.
 *
 * @param {Object} [currentUser]
 * @returns {boolean}
 */
export const canChangeEmailWithoutPassword = currentUser =>
  !!(currentUser?.id && currentUser.attributes && currentUser.attributes.emailVerified === false);

/**
 * Client error codes from POST /api/current-user/change-unverified-email
 */
export const UNVERIFIED_EMAIL_CODES = {
  GRANT_MISSING: 'grant_missing',
  TAKEN: 'email_taken',
  WRONG_PASSWORD: 'wrong_password',
  ALREADY_VERIFIED: 'already_verified',
  SAME_EMAIL: 'same_email',
  INVALID_EMAIL: 'invalid_email',
};

/**
 * Read a local API error code from a thrown response.
 *
 * @param {Object} [error]
 * @returns {string|null}
 */
export const unverifiedEmailErrorCode = error => {
  if (!error) {
    return null;
  }
  return error.code || error.data?.code || null;
};
